import Rate from "./rules-block/rate";
import RateCategory from "./rules-block/rateCategory";
import Date from "./rules-block/date";

export default class EventConfig {
	constructor(fields = {}) {
		this.id = fields.id || null;
		this.name = fields.name || "";
		this.start_date = fields.start_date || null;
		this.end_date = fields.end_date || null;
		this.timezone = fields.timezone || null;
		this.organizer_id = fields.organizer_id || null;
		this.is_closed = fields.is_closed || null;
		this.is_seated = fields.is_seated || null;
		this.is_date_event = fields.is_date_event || null;
		this.rates = fields?.rates?.map(Rate.buildFromJSON) ?? [];
		this.categories =
			fields?.categories?.map(RateCategory.buildFromJSON) ?? [];
		this.dates = fields?.dates?.map(Date.buildFromJSON) ?? [];
		Object.assign(this, fields);
	}

	static buildFromJSON(json) {
		return new EventConfig({
			id: json.id,
			name: json.name ?? "",
			start_date: json.start_date ?? null,
			end_date: json.end_date ?? null,
			timezone: json.timezone ?? null,
			organizer_id: json.organizer_id ?? null,
			is_closed: json.is_closed ?? null,
			is_seated: json.is_seated ?? null,
			is_date_event: json.is_date_event ?? null,
			rates: json.rates ?? [],
			categories: json.categories ?? [],
			dates: json.dates ?? []
		});
	}

	toJSON() {
		return {
			id: this.id,
			name: this.name,
			start_date: this.start_date,
			end_date: this.end_date,
			timezone: this.timezone,
			organizer_id: this.organizer_id,
			is_closed: this.is_closed,
			is_seated: this.is_seated,
			is_date_event: this.is_date_event,
			rates: this.rates,
			categories: this.categories,
			dates: this.dates
		};
	}

	getId() {
		return this.id;
	}

	getName() {
		return this.name;
	}

	getStartDate() {
		return this.start_date;
	}

	getEndDate() {
		return this.end_date;
	}
	getTimezone() {
		return this.timezone;
	}

	getOrganizerId() {
		return this.organizer_id;
	}

	getIsClosed() {
		return this.is_closed;
	}

	getIsSeated() {
		return this.is_seated;
	}

	getIsDateEvent() {
		return this.is_date_event;
	}

	getRates() {
		return this.rates;
	}

	getCategories() {
		return this.categories;
	}

	getDates() {
		return this.dates;
	}

	getRatesOrDates() {
		return this.rates || this.dates || [];
	}

	getCategoriesChildren() {
		return [
			...this.getRates(),
			...this.getCategories().filter(cat => cat.parent != null)
		];
	}

	getCatetegoriesHierarchy() {
		// Create a set of existing category IDs for quick checking
		const categoryIds = new Set(this.getCategories().map(({ id }) => id));

		const buildTree = (parentId = null) => {
			return this.getCategories()
				.filter(({ parent }) => parent === parentId)
				.map(cat => ({
					value: cat.id,
					text: cat.name,
					parent: parentId,
					children: [
						...buildTree(cat.id),
						...this.getRates()
							.filter(r => r.category === cat.id)
							.map(rate => ({
								value: rate.id,
								text: rate.name,
								parent: cat.id,
								isRate: true
							}))
					]
				}));
		};

		// Uncategorized rates to be added to the root
		const uncategorizedRates = this.getRates()
			.filter(rate => !rate.category || !categoryIds.has(rate.category))
			.map(rate => ({
				value: rate.id,
				text: rate.name,
				isRate: true
			}));

		return [...buildTree(), ...uncategorizedRates];
	}
}
